// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.main-title[data-v-dd6d29c4] {\n  color: var(--components-modal-color-default-title-color, #434049);\n\n  font-family: 'Montserrat';\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: normal;\n}\n.req-renew-ben-cards-plan[data-v-dd6d29c4] {\n  padding: 0 8px;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
